<template>
  <q-inner-loading :showing="showing">
    <q-spinner-ball size="50px" color="primary" />
  </q-inner-loading>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InnerLoading',
  components: {},
  props: {
    showing: Boolean,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
});
</script>

<style lang="scss">
.q-inner-loading {
  z-index: 1;
}
</style>
